import env                        from '../env';
import { ConversationList }       from '../types';
import { getSession }             from './SessionService';
import { fetchJSON }              from '@statflo/fetch';

interface ConversationListPayload {
    details: {
        details: ConversationList;
    }
}

export default async function conversationListService(filter: string = 'all'): Promise<ConversationList> {
    const session = await getSession();
    const endPoint = `${env.CONVERSATION_LIST_HOST}/v1/rest/conversations/?manager_filter=${filter}`;
    const requestInit: RequestInit = {
        method: 'GET',
        headers: new Headers({
            Authorization: `Bearer ${session.token}`
        }),
        mode: 'cors',
        cache: 'no-cache'
    };

    const { details: { details: conversationsList } } = await fetchJSON<ConversationListPayload>(endPoint, requestInit);

    return conversationsList;
}



// WEBPACK FOOTER //
// ./src/services/ConversationListService.ts